import { app } from '../app';

app.factory('Account', Account);

/** @ngInject */
function Account($http, $rootScope) {

    let promise;

    return {
        get,
        reload,
    };

    function get() {
        return promise || reload();
    }

    function reload() {
        promise = $http
            .get('app/rest/account')
            .then(response => response.data)
            .then(initialize)
        ;

        return promise;
    }

    function initialize(account) {
        $rootScope.sessionExpired = false;
        return $rootScope.account = account;
    }
}



// WEBPACK FOOTER //
// ./src/portal/services/account.service.js